module.exports = __webpack_public_path__ + "assets/images/premium-features/sick-callout-1c7f23.png";